import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import { COMPANY_VALUES } from "@/data/site";

export default function AboutSection() {
  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="about-section">
      <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <SectionHeader
            overline="About NEPHRC"
            title={<>A multidisciplinary consultancy<br />built on <span className="text-emerald-brand">engineering rigour</span>.</>}
            subtitle="From feasibility through commissioning, NEPHRC partners with governments, hospitality groups and retail operators to engineer outcomes that endure."
          />
          <Link
            to="/about"
            data-testid="about-section-cta"
            className="mt-8 inline-flex items-center gap-2 text-navy font-semibold text-sm border-b border-gold pb-1 hover:gap-3 transition-all"
          >
            Read our full story <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="sm:col-span-2 p-8 bg-navy text-white"
          >
            <div className="overline text-gold">Vision</div>
            <p className="mt-4 font-display text-2xl sm:text-3xl leading-snug">
              To be India&apos;s most trusted multidisciplinary consultancy — shaping infrastructure, hospitality and retail that strengthens communities for generations.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="p-8 border border-slate-200 bg-mist"
          >
            <div className="overline text-emerald-brand">Mission</div>
            <p className="mt-4 text-slate-brand leading-relaxed">
              Deliver engineering, architectural and consultancy excellence with transparent processes, sustainable practices and an unwavering client-first orientation.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="p-8 border border-slate-200 bg-mist"
          >
            <div className="overline text-emerald-brand">History</div>
            <p className="mt-4 text-slate-brand leading-relaxed">
              Founded by T G Dey, NEPHRC has grown from a regional engineering practice into a multi-city consultancy serving government, hospitality and retail clients across India.
            </p>
          </motion.div>

          <div className="sm:col-span-2 grid sm:grid-cols-3 gap-px bg-slate-200 mt-2">
            {COMPANY_VALUES.map((v) => (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5 }}
                className="bg-white p-6"
              >
                <div className="font-display font-semibold text-navy">{v.title}</div>
                <p className="mt-2 text-xs text-slate-brand leading-relaxed">{v.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
